/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const locationCreateRequestSchema = z.object({
  countryCode: z.string().min(1),
  holidaySchemeId: z.int().nullish(),
  subdivisionCode: z.string().nullish(),
  workloadSchemeId: z.int().nullish(),
});
